<template>
  <div class="input-box">
    <el-autocomplete
      ref="searchMenu"
      class="search-input"
      v-model="searchText"
      placeholder="搜索模块"
      popper-class="kye-popper-auto"
      value-key="label"
      clearable
      :trigger-on-focus="false"
      :fetch-suggestions="remoteMethod"
      @select="onChange">
      <i slot="prefix" class="el-input__icon el-icon-search" />
    </el-autocomplete>
    <div class="file-btn" @click="handleAdd" />
  </div>
</template>

<script>
export default {
  name: 'InputBox',
  data() {
    return {
      searchText: ''
    }
  },
  methods: {
    handleAdd() {
      this.$emit('add')
    },
    onChange(item) {
      this.$emit('select', item)
      this.searchText = ''
    },
    async remoteMethod(val, cb) {
      try {
        const res = await this.$http('system.homeModuleGroup.searchModule', { title: val, moduleType: 10 })
        const options = res.map(item => {
          return {
            ...item,
            label: `${item.moduleGroupName} > ${item.vo.title}`,
            text: item.vo.title
          }
        })
        cb(options)
        this.$nextTick(_ => {
          options.length && this.$refs['searchMenu'].highlight && this.$refs['searchMenu'].highlight(0)
        })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-box {
  display: flex;
  align-items: center;
  margin: 0 16px 12px;
  .search-input {
    flex: 1;
    min-width: 0;
    /deep/ .el-input{
      .el-input__inner {
        border-radius: 8px;
        border: 1px solid rgba(224, 223, 239, 1);
        background-color: #ffffff;
        padding-left: 23px;
      }
      .el-input__prefix{
        .el-icon-search{
          width: 18px;
          color: rgba(160, 158, 191, 1);
        }
      }
    }
  }
  .file-btn {
    width: 28px;
    height: 28px;
    border: 1px solid rgba(224, 223, 239, 1);
    cursor: pointer;
    border-radius: 8px;
    margin-left: 8px;
    display: block;
    flex-shrink: 0;
    background: url("../../../images/add-file.svg") no-repeat center center / 12px 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/sider/input-box.vue